<template>
  <div class="page-wrapper">
    <div class="imgbox">
      <div class="info">
        <p class="p1">欢迎</p>
        <p class="p2">财富之路，进无止境</p>
        <p class="p3">登录信源微信商城</p>
      </div>
    </div>
  </div>
</template>
<script>
  import * as getData from '../service/getData'
  import * as global from '../config/mUtils'

  var echarts = require('echarts');
  export default {
    data() {
      return {
        usernameview: '',
        activityTotal: '',
        userTotal: '',
        storeTotal: '',
        orderTotal: '',
        adminPortraitUrl: '',
        orderOptions: {},
        customerOptions: {},
        orderCharts: '',
        customerCharts: '',
        weekDate:['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        orderData:[320, 332, 301, 334, 390, 390, 390],
        userData:[220, 182, 191, 234, 290, 290, 290],
        data1:[],
        detailrolds:[],
      }
    },
    created() {
    },
    mounted() {
      this.detailrolds = JSON.parse(sessionStorage['detailrolds']);
      this.initindex();
      this.usernameview = sessionStorage['username'];
    },
    methods: {
      loginOut() {
        this.$router.push({path: '/login', query: {}})
      },
      windowSize(type) {
        let bodyClientWidth = document.body.clientWidth;
        this.orderCharts.resize();
        this.customerCharts.resize();
      },
      throttle(func, delay) { //函数节流
        var timer = null;
        var startTime = Date.now();
        return () => {
          var curTime = Date.now();
          var remaining = delay - (curTime - startTime);
          var context = this;
          var args = arguments;
          clearTimeout(timer);
          if (remaining <= 0) {
            func.apply(context, args);
            startTime = Date.now();
          } else {
            timer = setTimeout(func, remaining);
          }
        }
      },
      initindex() {
        getData.indexdetail().then((res) => {
          this.orderData=res.data.orderList
          this.userData=res.data.userList
          this.weekDate=res.data.datenewList
          this.userTotal = res.data.userTotal;
          this.activityTotal = res.data.activityTotal;
          this.storeTotal = res.data.storeTotal;
          this.orderTotal = res.data.orderTotal;
        })
      },

    },
    watch: {}
  }
</script>

<style lang="scss" scoped>
  .page-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    font-family: '黑体-繁';
    /*margin-top: 51px;*/
  }
  .page-wrapper{
    position: relative;
   overflow:hidden;
  }
  .page-wrapper .imgbox{
    width:100%;
    height:100%;
    height:100%;
    position: absolute;
    left: 0;
    top:0;
    background: url("../assets/img/indexbg.jpg") no-repeat;
    background-size:100% 100%;
  }
  .info{width:100%; height:280px; background:rgba(0,0,0,.1); position:relative;top:250px;}
  .p1{position:absolute; left:80px; top:55px; font-size:100px; color:#3891d8;}
  .p2{position:absolute;left:295px; top:86px; font-size:23px; color:#666;}
  .p3{position:absolute;left:295px; top:113px; font-size:50px; color:#f7a029;}
</style>



// WEBPACK FOOTER //
// src/view/indexForStore.vue